import Matter from 'matter-js';

export const matterStart = () => {
  let Engine = Matter.Engine,
      Render = Matter.Render,
      World = Matter.World,
      Bodies = Matter.Bodies;
      
  // create an engine
  var engine = Engine.create();
  let idRAF = null;

  function init(){
    cancelAnimationFrame(idRAF);
    const ua = navigator.userAgent.indexOf('Windows') === -1;
    let width = ua ? window.innerWidth : window.innerWidth - 20;
    let height;

    if (width > 800) {
      height = document.body.clientHeight - 194;
    } else if (width > 600) {
      height = 1118;
    } else {
      height = 1343;
    }
    
    let offset = -1;
    // module aliases
    
    engine.events = {};
    World.clear(engine.world);
    Engine.clear(engine);
    
    engine = Engine.create();
   
    engine.world.gravity.x = 0;
    engine.world.gravity.y = 0;
  
    // create a renderer
    let render = Render.create({
      element: document.body,
      engine: engine,
      options: {
        wireframes: false,
        background: 'transparent',
        width: width,
        height: height,
        hasBounds: true,
        enabled: true,
        showDebug: false,
        showBroadphase: false,
        showBounds: false,
        showVelocity: false,
        showCollisions: false,
        showSeparations: false,
        showAxes: false,
        showPositions: false,
        showAngleIndicator: false,
        showIds: false,
        showShadows: false,
        showVertexNumbers: false,
        showConvexHulls: false,
        showInternalEdges: false,
        showMousePosition: false
      }
    });

    var CanvasEl = document.getElementsByTagName('canvas')[0];
    CanvasEl.style.position = 'absolute';
    CanvasEl.style.top = '0px';

    // create two boxes and a ground
    // add all of the bodies to the world
    World.add(engine.world, [
  //     Bodies.rectangle(width, height, width, 1, {
  //       isStatic: true,
  //       render: {
  //         fillStyle: "transparent"
  //       }
  //     }),
  
  //     Bodies.rectangle(width / 10, 400, width / 5, 100, {
  //       isStatic: true,
  //       render: {
  //         fillStyle: "transparent"
  //       }
  //     }),
  //     Bodies.rectangle(width -300, (height / 3), width / 5, 100, {
  //       isStatic: true,
  //       render: {
  //         fillStyle: "transparent"
  //       }
  //     }),
      Bodies.rectangle(width / 3, window.innerHeight / 3, width / 5, 1, {
        isStatic: true,
        render: {
          fillStyle: "transparent"
        }
      }),
      Bodies.rectangle(width, window.innerHeight - 90, width / 4, 1, {
        isStatic: true,
        render: {
          fillStyle: "transparent"
        }
      }),
      Bodies.rectangle(width / 2, height - offset, width, 1, {
        isStatic: true,
        render: {
          fillStyle: "transparent"
        }
      }),
      Bodies.rectangle(width / 2, offset, width, 1, {
        isStatic: true,
        render: {
          fillStyle: "transparent"
        }
      }),
      Bodies.rectangle(offset, height / 2, 1, height, {
        isStatic: true,
        render: {
          fillStyle: "transparent"
        }
      }),
      Bodies.rectangle(width - offset, height / 2, 1, height, {
        isStatic: true,
        render: {
          fillStyle: "transparent"
        }
      })
    ]);
 


const colorSet = [
  'rgba(255,255,255,0.9)',
  'rgba(255,218,61, 0.9)', // yellow
  'rgba(157,231,85,0.9)', // lime
  'rgba(39,207,102,0.9)', // green
  'rgba(98,151,249,0.9)', // blue
  'rgba(141,132,239,0.9)', // purple
  'rgba(255,149,161,0.9)', // pink
  'rgba(237,65,43,0.9)' // red
];
  
  for (let j = 0; j < 2; j++) {
    for (let i = 0; i < colorSet.length; i++) {
      let radius = width > 1024 ? 20 + Math.random() * 120 : 20 + Math.random() * 40;
      World.add(engine.world, Bodies.circle(
        40 + Math.random() * width / 2,
        40 + Math.random() * 100,
        radius, {
          render: {
  //           fillStyle: ["#4285F4", "#EA4335", "#FBBC05", "#34A853"][Math.round(Math.random() * 3)]
            fillStyle: colorSet[i]
          }
        }
      ));
    }
  }

  var mouseConstraint = Matter.MouseConstraint.create(engine, { //Create Constraint
    element: CanvasEl,
    constraint: {
      render: {
            visible: false
        },
        stiffness:0.8
      }
  });
  Matter.World.add(engine.world, mouseConstraint);
  mouseConstraint.mouse.element.removeEventListener("mousewheel", mouseConstraint.mouse.mousewheel);
  mouseConstraint.mouse.element.removeEventListener("DOMMouseScroll", mouseConstraint.mouse.mousewheel);
  mouseConstraint.mouse.element.removeEventListener("touchmove", mouseConstraint.mouse.mousemove);
  mouseConstraint.mouse.element.removeEventListener("touchstart", mouseConstraint.mouse.mousedown);
  
    // run the engine
    Engine.run(engine);
   
    // run the renderer
    Render.run(render);
   
    let inc = 0
   
    engine.world.gravity.y = 0.3;
    function update() {
      if(inc > 180){
        engine.world.gravity.x = Math.cos(inc / 55)
        engine.world.gravity.y = Math.sin(inc / 150)
      }
      inc++
      idRAF = requestAnimationFrame(update.bind(this))
    }
   
    update();
  }
  init()
   
  // function debounce(func, wait, immediate) {
  //    var timeout;
  //    return function() {
  //      var context = this, args = arguments;
  //      var later = function() {
  //      timeout = null;
  //      if (!immediate) func.apply(context, args);
  //    };
  //    var callNow = immediate && !timeout;
  //    clearTimeout(timeout);
  //    timeout = setTimeout(later, wait);
  //    if (callNow) func.apply(context, args);
  //    };
  //  };
  //  
  //  window.addEventListener('resize', debounce(function(){
  //   init();
  //   var CanvasEl = document.getElementsByTagName('canvas')[0];
  //   document.body.removeChild(CanvasEl);
  //   CanvasEl = document.getElementsByTagName('canvas')[0];
  //   CanvasEl.style.position = 'absolute';
  //   CanvasEl.style.top = '0px';
  //  }, 200));

  this.globalEngine = engine; // eslint-disable-line no-alert
};

export const matterExit = () => {
  Matter.World.clear(this.globalEngine.world);
  Matter.Engine.clear(this.globalEngine);
  var CanvasEl = document.getElementsByTagName('canvas')[0];
  document.body.removeChild(CanvasEl);
};



// WEBPACK FOOTER //
// ./src/lib/matter.js